<template>
    <div>
        <h1>MyProjects</h1>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>